import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

const routerErrror = failure => {
  if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
    failure.to.path // '/admin'
    failure.from.path // '/'
  }
}

export { routerErrror }
